import { useState, useEffect, useRef } from "react";
import SearchBar from "../../components/search/SearchBar";
import EmployeeGridView from "../../components/search/EmployeeGridView";
import UserLayout from "../../component/Layout";
import { useSelector } from "react-redux";
import { fetchEmployees } from "../../services/Service";

const EmployeeSearch = () => {
  const [data, setData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const searchBarRef = useRef(null);
  const employeeGridRef = useRef(null);
  const token = useSelector((state) => state.auth.token);

  const fetchEmployeeData = async () => {
    try {
      const data = await fetchEmployees(page - 1, pageSize, token);

      if (data && Array.isArray(data.content)) {
        setData(data.content);
        setSearchResults(data.content);
        setTotalRecords(data.totalElements);
        setSearchPerformed(false);
      } else {
        console.error("Expected an array but got:", data);
        setData([]);
        setSearchResults([]);
        setTotalRecords(0);
        setSearchPerformed(false);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  useEffect(() => {
    if (!searchPerformed) {
      fetchEmployeeData();
    }
  }, [page, pageSize, token]);

  const handleSearch = (filteredData) => {    
    setSearchResults(filteredData);
    setTotalRecords(filteredData.length);
    setSearchPerformed(true);
    if (employeeGridRef.current) {
      employeeGridRef.current.focus();
    }
  };

  const handleReset = () => {
    fetchEmployeeData(); // Reset data
  };

  const handleResetSelectedRows = () => {
    if (employeeGridRef.current && employeeGridRef.current.resetSelectedRows) {
      employeeGridRef.current.resetSelectedRows();
    }
  };

  return (
    <UserLayout>
      <main className="p-6 w-full max-w-screen-lg mx-auto">
        <SearchBar
          ref={searchBarRef}
          data={data}
          onSearch={handleSearch}
          onReset={() => {
            handleReset();
            handleResetSelectedRows(); 
          }}
        />
        <EmployeeGridView
          ref={employeeGridRef}
          searchResults={searchResults}
          page={page}
          pageSize={pageSize}
          totalRecords={totalRecords}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          searchPerformed={searchPerformed}
          resetSelectedRows={handleResetSelectedRows} 
        />
      </main>
    </UserLayout>
  );
};

export default EmployeeSearch;